import { useState, useEffect } from 'react'

export const useLocalDataSync = ({ data }) => {
    const [localData, setLocalData] = useState(data ? [...data] : [])

    useEffect(() => {
        if (data && ((localData.length === 0 && data.length > 0) ||
                     localData.length !== data.length ||
                     !localData.every((value, index) => value === data[index]))) {
            setLocalData([...data])
        }
    }, [data, localData])

    return { localData, setLocalData }
}
